import { instance2 } from './base';

export const login = (username: string, password: string): Promise<any> =>
    instance2
        .post(
            '/api/v1/login',
            {
                username: username,
                password: password,
            },
            {},
        )
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error;
        });

export const signup = (username: string, password: string): Promise<any> =>
    instance2
        .post(
            '/api/v1/registration',
            {
                email: username,
                password: password,
            },
            {},
        )
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error;
        });

export const checkProfile = () =>
    instance2
        .get('/api/v1/check-token', {
            params: {},
        })
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error;
        });

export const updPassword = (password: string, confirmPassword: string): Promise<any> =>
    instance2
        .post(
            '/api/v1/password/change',
            {
                password: password,
                password_confirmation: confirmPassword,
            },
            {},
        )
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error;
        });

export const forgotPassword = (email: string): Promise<any> =>
    instance2
        .post(
            '/api/v1/password/forgot',
            {
                username: email,
            },
            {},
        )
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error;
        });

export const resetPassword = (token: string, email: string, pw: string, pwConfirm: string): Promise<any> =>
    instance2
        .post(
            '/api/v1/password/reset',
            {
                token: token,
                email: email,
                password: pw,
                password_confirmation: pwConfirm,
            },
            {
                headers: {},
            },
        )
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error;
        });

export const checkToken = (tokenType: string, token: string): Promise<any> =>
    instance2
        .post(
            '/api/v1/check-token',
            {
                token_type: tokenType,
                token: token,
            },
            {
                headers: {},
            },
        )
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error;
        });

export const resendVerificationEmail = (email: string): Promise<any> =>
    instance2
        .post(
            '/api/v1/registration/resend',
            {
                email: email,
            },
            {
                headers: {},
            },
        )
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error;
        });

export const verifyEmail = (tenantId: string | null, email: string, token: string): Promise<any> =>
    instance2
        .get('/api/v1/registration/verify', {
            params: {
                email: email,
                token: token,
            },
            headers: tenantId ? { 'X-Tenant': tenantId } : {},
        })
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error;
        });

export const loginExternal = (data: any): Promise<any> =>
    instance2
        .post('/api/v1/auth/login-register-external', data, {})
        .then((response) => {
            console.log(response);
            return response;
        })
        .catch((error) => {
            return error;
        });
export const storeDeviceToken = (token: string, platform: string, deviceName: string | null): Promise<any> =>
    instance2
        .post(
            '/api/v1/auth/device-token',
            {
                device_token: token,
                platform: platform,
                device_name: deviceName || null,
            },
            {},
        )
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error;
        });

export const removeDeviceToken = (token: string): Promise<any> =>
    instance2
        .delete('/api/v1/auth/device-token', {
            data: {
                device_token: token,
            },
        })
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error;
        });

export const getAccountVerifiedHtml = (
    tenantId: string | null,
    email: string | null,
    token: string | null,
): Promise<any> =>
    instance2
        .get('/api/v1/customers/account-verified', {
            params: {
                email: email,
                token: token,
            },
            headers: {
                'X-Tenant': tenantId || '',
            },
        })
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error;
        });

